var React = require('react');

function FolderInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#221b16;}")),React.createElement("g",{"transform":"translate(-730 -115)","key":1},[React.createElement("rect",{"className":"a","width":"18","height":"13","rx":"2","transform":"translate(730 117)","key":0}),React.createElement("rect",{"className":"a","width":"10","height":"9","rx":"2","transform":"translate(730 115)","key":1})])]);
}

FolderInline.defaultProps = {"width":"18","height":"15","viewBox":"0 0 18 15"};

module.exports = FolderInline;

FolderInline.default = FolderInline;
